// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__K-fH7","xl":"Title_xl__uaGH9","lg":"Title_lg__R5Mkq","md":"Title_md__FVyZ3","sm":"Title_sm__73PL-","light":"Title_light__Pt0S4","white":"Title_white__w4sSY"};